import axios from "axios";
import apiService from "../../services/apiService";
const ORDER_API = process.env.REACT_APP_ORDER_BACKEND_API;
export const getShippingRules = async () => {
  try {
    const { data } = await axios.get(`${ORDER_API}/frontend/shipping-rules`);
    return data?.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch shipping rukes.",
    );
  }
};
export const getUserOrders = async () => {
  const res = await apiService.get(`${ORDER_API}/backend/my-orders`);
  return res?.data?.orders || [];
};
export const addUserOrder = async (payload) => {
  const response = await apiService.create(
    `${ORDER_API}/backend/payments/cod`,
    payload,
  );
  return response?.data;
};
export const payWithPayU = async (payload) => {
  const response = await apiService.create(
    `${ORDER_API}/backend/payments/payu`,
    payload,
  );

  return response?.data;
};
export const payWithPaypal = async (payload) => {
  const response = await apiService.create(
    `${ORDER_API}/backend/payments/paypal`,
    payload,
  );
  return response?.data;
};

export const payWithRazorpay = async (payload) => {
  const response = await apiService.create(
    `${ORDER_API}/backend/payments/razorpay`,
    payload,
  );

  return response?.data;
};
export const verifyRazorpayPayment = async (payload) => {
  const response = await apiService.post(
    `${ORDER_API}/backend/payments/razorpay/verify`,
    payload,
  );

  return response.data;
};
export const razorpayPaymentFailed = async (payload) => {
  const response = await apiService.post(
    `${ORDER_API}/backend/payments/razorpay/failure`,
    payload,
  );
  return response.data;
};

export const updatePayUStatus = async ({ txnid, status }) => {
  const response = await apiService.post(
    `${ORDER_API}/backend/payments/payu/status`,
    { txnid, status },
  );
  return response?.data;
};
export const cancelUserOrder = async (id) => {
  const { data } = await apiService.post(
    `${ORDER_API}/backend/my-orders/${id}/cancel`,
    {},
    { headers: { "Content-Type": "application/json" } },
  );
  return data?.data;
};
export const getUserOrderById = async (id) => {
  const { data } = await apiService.getById(
    `${ORDER_API}/backend/my-orders/${id}`,
  );
  return data?.data;
};
export const getOrderInvoice = async (invoiceNumber) => {
  const res = await apiService.getById(
    `${ORDER_API}/backend/my-orders`,
    invoiceNumber,
  );
  const order = res.data?.order;
  if (!order) throw new Error("Invoice not found");
  return order;
};
